export const SITELINK_MAP = {
  // Phase 1
  "c++ basics": "cpp-basics",
  "c++ stl": "cpp-stl",
  "basic maths": "basic-maths",
  "codeforces problem a grind": "a-grind",
  "number theory": "basic-number-theory",
  "binary search": "binary-search-stl",
  "greedy algorithms": "greedy",
  "constructive algorithms": "constructive-algorithms",
  "game theory basic to advanced": "game-theory",
  "codeforces problem b grind": "b-grind",
  "recursion and backtracking": "backtracking",
  "bit manipulation": "bit-manipulation",
  "advanced game theory": "advanced-game-theory",
  "advanced number theory": "advanced-number-theory",
  "basic probability": "basic-probability",
  combinatorics: "combinatorics",
  "directed graphs": "directed-graphs",
  "segment-trees-and-lazy propagation": "lazy-propagation",
  dsu: "dsu",
  "interactive problems": "interactive-problems",
  "two-pointers": "two-pointers",
  "codeforces c problem grind": "c-grind",
  "codeforces d problem grind": "d-grind",
  dp: "grid-dp", // API is not prepared for dp yet
  "non-standard dp problems": "grid-dp", // API is not prepared for dp yet
  "non-standard graph problems": "directed-graphs", // API is not prepared for non-standard graph problems yet
  graphs: "directed-graphs", // API is not prepared for graphs yet
  "codeforces e problem grind": "d-grind", // API is not prepared for e grind yet

  // Phase 2
  "basic recursion": "basic-recursion",
  "geometry for beginners": "geometry-for-beginners",
  "basic adhoc": "basic-adhoc",
  "1d prefix sum": "one-d-prefix-sum",

  // Phase 3
  "greedy advanced": "greedy-advanced",
  "binary search on answer": "binary-search-on-answer",
  "custom sorting": "custom-sorting",
  bitmasking: "bitmasking",
  "moderate number theory": "moderate-number-theory",
  "modular arithmetic": "modular-arithmetic",
  "sliding window": "sliding-window",

  // Phase 4
  "2d prefix sum & difference array": "two-d-prefix-sum-and-difference-array",
  "basic trees/ dfs": "basic-trees-dfs",
  bfs: "bfs",
  djikstra: "djikstra",
  mst: "mst",
  "introductory dp": "introductory-dp",
  "grid dp": "grid-dp",
  "lis dp": "lis-dp",
  "knapsack dp": "knapsack-dp",
  "segment tree": "segment-tree",
  "inclusion exclusion": "inclusion-exclusion",
  stacks: "stacks",
  tries: "tries",
  "suffix array": "suffix-array",

  // Phase 5
  "small to large merging": "small-to-large-merging",
  "binary lifting": "binary-lifting",
  "dp on trees": "dp-on-trees",
  "re-rooting": "re-rooting",
  "euler tour": "euler-tour",
  "heavy light decomposition": "heavy-light-decomposition",
  "centroid decomposition": "centroid-decomposition",
  "topological sort": "topological-sort",
  "dp on dag": "dp-on-dag",
  "tarjan's algorithm": "tarjan's-algorithm",
  "0-1 bfs": "zero-one-bfs",
  scc: "scc",
  "eppstein's algorithm": "eppstein's-algorithm",
  "bellman ford algorithm": "bellman-ford-algorithm",
  "floyd warshal algorithm": "floyd-warshal-algorithm",
  "bitmask dp": "bitmask-dp",
  "digit dp": "digit-dp",
  "combinatorial dp": "combinatorial-dp",
  "range dp": "range-dp",
  "matrix exponentiation": "matrix-exponentiation",
  "markov chains": "markov-chains",
  "randomized algorithm": "randomized-algorithm",
  "fenwick trees": "fenwick-trees",
  "square root decomposition": "square-root-decomposition",
  pbds: "pbds",
  "sparse table": "sparse-table",
  "mo's algorithm": "mo's-algorithm",
  "z algorithm": "z-algorithm",
  kmp: "kmp",
  "string suffix structure": "string-suffix-structure",

  // Phase 6
  "state optimization": "state-optimization",
  "convex hull": "convex-hull",
  "sos dp": "sos-dp",
  "divide and conquer": "divide-and-conquer",
  "li chao tree": "li-chao-tree",
  "slope trick": "slope-trick",
  "dp on broken profile": "dp-on-broken-profile",
  "plug dp": "plug-dp",
  "segment tree optimization": "segment-tree-optimization",
  "1d1d optimization": "one-done-d-optimization",
  "knuth's optimization": "knuth's-optimization",
  flows: "flows",
  "meet in the middle": "meet-in-the-middle",
  "chinese remainder theorem": "chinese-remainder-theorem",
  fft: "fft",
  "generating functions": "generating-functions",
  ntt: "ntt",
  "xor basis": "xor-basis",
  bcc: "bcc",
  "2cc": "2cc",
  "link cut trees": "link-cut-trees",
  "offline deletion": "offline-deletion",
  "2-sat": "two-sat",
  treaps: "treaps",
  "virtual tree": "virtual-tree",
  "dynamic segment trees": "dynamic-segment-trees",
  "persistance segment trees": "persistance-segment-trees",
  "wavelet trees": "wavelet-trees",
};
